import { render } from "./app.vue?vue&type=template&id=1de03c8d&ts=true"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"

import "./app.vue?vue&type=style&index=0&id=1de03c8d&lang=css"

import exportComponent from "/Users/cuixg/Desktop/web/magic/admin/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__